import { z } from "zod";

import { createPaginatedResponseSchema } from "../api/pagination";
import { type Distance, DistanceSchema } from "../location/distance";
import {
  type UserLocation,
  UserLocationSchema,
} from "../location/user_location";
import {
  type UserProfileAttributes,
  UserProfileAttributesSchema,
} from "../profile/UserProfileAttributes";

import {
  type UserImageMedia,
  UserImageMediaSchema,
} from "@/schemas/user/image";

export type UserProfilePreview = {
  username: string;
  avatar: UserImageMedia | null;
  lastActivityTime: number;
  isFollowing: boolean;
  isBlocked: boolean;
  followerCount: number;
  followingCount: number;
  separation: Distance | null;
  attributes: UserProfileAttributes;
  location: UserLocation | null;
};

export const UserProfilePreviewSchema = z.object({
  username: z.string(),
  avatar: UserImageMediaSchema.nullable(),
  lastActivityTime: z.number(),
  isFollowing: z.boolean(),
  isBlocked: z.boolean(),
  followerCount: z.number(),
  followingCount: z.number(),
  separation: DistanceSchema.nullable(),
  attributes: UserProfileAttributesSchema,
  location: UserLocationSchema.nullable(),
});

export const PaginatedUserProfilePreviewSchema = createPaginatedResponseSchema(
  UserProfilePreviewSchema,
);
